import React from "react";

import SendTemplateDrawer from "./SendTemplateDrawer";

/**
 * Bulk "Send WhatsApp" from the leads list. Templates are the Meta-approved
 * ones wrapped by the activitytemplate app, so only variable values are
 * editable here.
 */
const SendWAMessageDrawer = ({ open, onClose, selectedRecords = [], onSent }) => (
  <SendTemplateDrawer
    open={open}
    onClose={onClose}
    channel="WHATSAPP"
    leads={selectedRecords}
    onSent={onSent}
  />
);

export default SendWAMessageDrawer;
